export const style = {
  gridContainer: {
    justifyContent: 'space-between',
  },
  detailsContainer: {
    justifyContent: 'flex-start',
  },
  boxRow: {
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  image: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  section: {
    paddingTop: '8px',
  },
  mainContainer: {
    mt: 2,
    columns: 12,
    spacing: 2,
  },
  btn: {
    variant: 'contained',
    sx: {
      backgroundColor: 'secondary.main',
    },
    size: 'medium',
  },
  typography: {
    variant: 'h4',
    marginBottom: '10px',
  },
  talentInfo: {
    blockInfo: {
      display: 'flex',
      gap: '2px',
      color: '#130F35',
      alignItems: 'center',
      pt: 1,
    },
    container: {
      paddingTop: '10px',
    },
    talentTitle: {
      typography: {
        variant: 'h4',
      },
    },
  },
  header: {
    style: {
      paddingTop: '8px',
      paddingBottom: '8px',
    },
    sx: {
      backgroundColor: 'background.default',
    },
  },
  lastChangedBy: {
    maxWidth: '470px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  ClockOutlinedIcon: {
    fontSize: '20px',
    marginTop: '5px',
  },
  clipboard: {
    '&:hover svg': {
      display: 'block',
    },
    '&:not(:hover) svg': {
      display: 'none',
    },
  },
  oulineClockWrapper: {
    display: 'flex',
  },
} as const;
